module.exports = __webpack_public_path__ + "static/media/battles.0ec0e820.svg";